import {
  KEEPER,
  CENTRE_BACK,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_RIGHT,
  FULL_BACK_LEFT,
  SWEEPER,
  WING_BACK_RIGHT,
  WING_BACK_LEFT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  DEFENSIVE_MIDFIELD,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  CENTRE_FORWARD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD,
  WINGER_RIGHT,
  WINGER_LEFT,
  SECOND_STRIKER,
  STRIKER,
  STRIKER_RIGHT,
  STRIKER_LEFT,
  formationPlaceType,
} from './player';

/** FORMATIONS */
export type teamFormations =
  | '3142'
  | '3241'
  | '3331'
  | '3412'
  | '3421'
  | '343'
  | '343d'
  | '3511'
  | '352'
  | '41212'
  | '4132'
  | '4141'
  | '4222'
  | '4231'
  | '4240'
  | '4312'
  | '4321'
  | '433'
  | '4411'
  | '442'
  | '451'
  | '532'
  | '541';
export type teamFormationsToMap = '3142' | '343d' | '41212' | '4240';
export type teamFormation = teamFormations | teamFormationsToMap;

export const FORMATION_3142: teamFormation = '3142';
export const FORMATION_3241: teamFormation = '3241';
export const FORMATION_3331: teamFormation = '3331';
export const FORMATION_3412: teamFormation = '3412';
export const FORMATION_3421: teamFormation = '3421';
export const FORMATION_343: teamFormation = '343';
export const FORMATION_343D: teamFormation = '343d';
export const FORMATION_3511: teamFormation = '3511';
export const FORMATION_352: teamFormation = '352';
export const FORMATION_41212: teamFormation = '41212';
export const FORMATION_4132: teamFormation = '4132';
export const FORMATION_4141: teamFormation = '4141';
export const FORMATION_4222: teamFormation = '4222';
export const FORMATION_4231: teamFormation = '4231';
export const FORMATION_4240: teamFormation = '4240';
export const FORMATION_4312: teamFormation = '4312';
export const FORMATION_4321: teamFormation = '4321';
export const FORMATION_433: teamFormation = '433';
export const FORMATION_4411: teamFormation = '4411';
export const FORMATION_442: teamFormation = '442';
export const FORMATION_451: teamFormation = '451';
export const FORMATION_532: teamFormation = '532';
export const FORMATION_541: teamFormation = '541';

export const teamFormationList: readonly teamFormation[] = [
  FORMATION_3142,
  FORMATION_3241,
  FORMATION_3331,
  FORMATION_3412,
  FORMATION_3421,
  FORMATION_343,
  FORMATION_343D,
  FORMATION_3511,
  FORMATION_352,
  FORMATION_41212,
  FORMATION_4132,
  FORMATION_4141,
  FORMATION_4222,
  FORMATION_4231,
  FORMATION_4240,
  FORMATION_4312,
  FORMATION_4321,
  FORMATION_433,
  FORMATION_4411,
  FORMATION_442,
  FORMATION_451,
  FORMATION_532,
  FORMATION_541,
];

type IFormationType = {
  [key in teamFormation]: formationPlaceType[];
};

export const FORMATION_3142_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  DEFENSIVE_MIDFIELD,
  WING_BACK_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  WING_BACK_LEFT,
  STRIKER_RIGHT,
  STRIKER_LEFT,
];

export const FORMATION_3241_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  SWEEPER,
  CENTRE_BACK_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_3331_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD,
  DEFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  WINGER_RIGHT,
  WINGER_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_3412_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  WING_BACK_RIGHT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  WING_BACK_LEFT,
  OFFENSIVE_MIDFIELD,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_3421_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  WING_BACK_RIGHT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  WING_BACK_LEFT,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_343_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  WINGER_RIGHT,
  CENTRE_FORWARD,
  WINGER_LEFT,
];

export const FORMATION_343D_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  DEFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  WINGER_RIGHT,
  STRIKER,
  WINGER_LEFT,
];

export const FORMATION_3511_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  CENTRE_FORWARD,
];

export const FORMATION_352_PLAYERS: formationPlaceType[] = [
  KEEPER,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  WING_BACK_RIGHT,
  DEFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD,
  DEFENSIVE_MIDFIELD_LEFT,
  WING_BACK_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_41212_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  DEFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_RIGHT,
  SIDE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  STRIKER_RIGHT,
  STRIKER_LEFT,
];

export const FORMATION_4132_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  DEFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_4141_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  DEFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  STRIKER,
];

export const FORMATION_4222_PLAYERS: formationPlaceType[] = [
  KEEPER,
  WING_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  WING_BACK_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_4231_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  DEFENSIVE_MIDFIELD_RIGHT,
  DEFENSIVE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_4240_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  WINGER_RIGHT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
  WINGER_LEFT,
];

export const FORMATION_4312_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD,
  WINGER_RIGHT,
  WINGER_LEFT,
];

export const FORMATION_4321_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  OFFENSIVE_MIDFIELD_RIGHT,
  OFFENSIVE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_433_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  WINGER_RIGHT,
  CENTRE_FORWARD,
  WINGER_LEFT,
];

export const FORMATION_4411_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  SECOND_STRIKER,
  CENTRE_FORWARD,
];

export const FORMATION_442_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_451_PLAYERS: formationPlaceType[] = [
  KEEPER,
  FULL_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK_LEFT,
  FULL_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const FORMATION_532_PLAYERS: formationPlaceType[] = [
  KEEPER,
  WING_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  SWEEPER,
  CENTRE_BACK_LEFT,
  WING_BACK_LEFT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD,
  CENTRE_MIDFIELD_LEFT,
  CENTRE_FORWARD_RIGHT,
  CENTRE_FORWARD_LEFT,
];

export const FORMATION_541_PLAYERS: formationPlaceType[] = [
  KEEPER,
  WING_BACK_RIGHT,
  CENTRE_BACK_RIGHT,
  CENTRE_BACK,
  CENTRE_BACK_LEFT,
  WING_BACK_LEFT,
  SIDE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_RIGHT,
  CENTRE_MIDFIELD_LEFT,
  SIDE_MIDFIELD_LEFT,
  CENTRE_FORWARD,
];

export const formations: IFormationType = {
  [FORMATION_3142]: FORMATION_3142_PLAYERS,
  [FORMATION_3241]: FORMATION_3241_PLAYERS,
  [FORMATION_3331]: FORMATION_3331_PLAYERS,
  [FORMATION_3412]: FORMATION_3412_PLAYERS,
  [FORMATION_3421]: FORMATION_3421_PLAYERS,
  [FORMATION_343]: FORMATION_343_PLAYERS,
  [FORMATION_343D]: FORMATION_343D_PLAYERS,
  [FORMATION_3511]: FORMATION_3511_PLAYERS,
  [FORMATION_352]: FORMATION_352_PLAYERS,
  [FORMATION_41212]: FORMATION_41212_PLAYERS,
  [FORMATION_4132]: FORMATION_4132_PLAYERS,
  [FORMATION_4141]: FORMATION_4141_PLAYERS,
  [FORMATION_4222]: FORMATION_4222_PLAYERS,
  [FORMATION_4231]: FORMATION_4231_PLAYERS,
  [FORMATION_4240]: FORMATION_4240_PLAYERS,
  [FORMATION_4312]: FORMATION_4312_PLAYERS,
  [FORMATION_4321]: FORMATION_4321_PLAYERS,
  [FORMATION_433]: FORMATION_433_PLAYERS,
  [FORMATION_4411]: FORMATION_4411_PLAYERS,
  [FORMATION_442]: FORMATION_442_PLAYERS,
  [FORMATION_451]: FORMATION_451_PLAYERS,
  [FORMATION_532]: FORMATION_532_PLAYERS,
  [FORMATION_541]: FORMATION_541_PLAYERS,
};
